import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface ISlice {
  tableFetchFlag: boolean;
}

const initialState: ISlice = {
  tableFetchFlag: false,
};

const SahraConnectionsSlice = createSlice({
  name: "sahraConnections",
  initialState,
  reducers: {
    setSahraConnectionsTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>
    ) => {
      store.tableFetchFlag = action.payload;
    },
  },
});

export const { setSahraConnectionsTableFetchDataFlag } =
  SahraConnectionsSlice.actions;
export default SahraConnectionsSlice.reducer;
